import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Patient } from '../../core/models/patient.model';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { Appointment } from '../../core/models/appointment.model';
import { MessagingService } from '../../core/services/messaging.service';
import { NotificationService } from '../../core/services/notification.service';
import { Message } from '../../core/models/message.model';
import { ChatSocketService } from '../../core/services/chat_socket_service';
import { BookingService } from '../../core/services/booking.service';

@Component({
  selector: 'app-messaging-component',
  imports: [FormsModule, PickerModule],
  templateUrl: './messaging-component.html',
  styleUrl: './messaging-component.scss',
})
export class MessagingComponent implements OnInit {
  message: string = '';
  isLoading = true;
  patient: Patient | undefined;
  booking: Appointment | undefined;
  bookingId: string | undefined;
  showEmojiPicker = false;
  //liveChatUrl = 'wss://<api-id>.execute-api.<region>.amazonaws.com/production?userId=';

  // ws : WebSocket | undefined;

  messages: Message[] | undefined;

  constructor(
    private messagingService: MessagingService,
    private notificationService: NotificationService,
    private bookingService: BookingService,
  ) {}

  ngOnInit(): void {
    this.booking = history.state['booking'];

    if (!this.booking) {
      this.bookingId = history.state['bookingId'];
    } else {
      this.bookingId = this.booking.id;
    }

    if (!this.booking) {
      this.bookingService.getPatientBooking(this.bookingId).subscribe((res) => {
        this.booking = res;
        this.patient = this.booking?.patient;
      });
    }

    this.loadMessages();
    // this.initiateMessageListener();
  }

  // initiateMessageListener() {
  //   this.chatSocketService.messages$.subscribe((msg) => {
  //     if (!!msg && !!this.messages) {
  //       this.messages.push(msg);
  //     }
  //   });
  // }

  loadMessages() {
    this.messagingService.getMessages(this.bookingId).subscribe(
      (res) => {
        this.messages = res;
        const sortedMessages = [...this.messages].sort((a, b) => {
          const timeA = a.sentTime ? new Date(a.sentTime).getTime() : 0;
          const timeB = b.sentTime ? new Date(b.sentTime).getTime() : 0;
          return timeA - timeB;
        });

        this.messages = sortedMessages;
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.notificationService.error(err.error.message);
      },
    );
  }

  sendMessage() {
    let message: Message = {
      content: this.message,
      receiverId: this.booking?.patient.id,
      senderId: this.booking?.doctor.user.id,
      sentTime: null,
      bookingId: this.booking?.id,
      id: null,
      conversationId: null,
    };

    // this.chatSocketService.send(message, () => {
    //   if (!!this.messages) {
    //     this.messages.push(message);
    //     this.message = '';
    //   }
    // }, () => {

    // });

    this.messagingService.sendMessage(message).subscribe(
      (res) => {
        if (!!this.messages) {
          this.messages.push(message);
          this.message = '';
        }
      },
      (err) => {
        this.notificationService.error(err.error.message);
      },
    );
  }

  toggleEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  addEmoji(event: any) {
    this.message += event.emoji.native;
  }

  isMe(id: string | undefined): boolean {
    console.log('iddd', id);
    return this.booking?.doctor.user.id === id;
  }
}
